import { useMemo, useCallback, FC } from 'react'
import { ListDropdown } from 'components/atoms/dropdowns/ListDropdown'
import { Timeframe } from 'interfaces/chart'
import { TimeframeOption } from 'interfaces/meta'
import { AnalyticsEvent } from 'interfaces/analytics'
import { TimeframedPage } from 'interfaces/pages'

const TimeframeInlineDropdown: new () => ListDropdown<Timeframe> = ListDropdown as any

export type TimeframeSelectStateProps = {
  options: TimeframeOption[]
  selected: Timeframe
}

export type TimeframeSelectDispatchProps = {
  changeTimeframe: (timeframe: Timeframe) => void
  trackUIEvent: (event: AnalyticsEvent) => void
}

export type TimeframeSelectOwnProps = {
  type: TimeframedPage
  isFuture?: boolean
  className?: string
  captionClassName?: string
  withArrow?: boolean
}

type TimeframeSelectProps =
  & TimeframeSelectStateProps
  & TimeframeSelectDispatchProps
  & TimeframeSelectOwnProps

export const TimeframeSelect: FC<TimeframeSelectProps> = (props) => {
  const {
    options,
    selected,
    changeTimeframe,
    trackUIEvent,
    className,
    captionClassName,
    withArrow,
  } = props

  const selectedOption = useMemo(() => {
    return options.find(({ id }) => id === selected) || options[0]
  }, [options, selected])

  const handleSelectTimeframe = useCallback(({ id }: TimeframeOption) => {
    changeTimeframe(id)
    trackUIEvent({
      category: 'site_controls-timeframe_filter',
      action: 'select',
      label: `${ selected } → ${ id }`,
    })
  }, [changeTimeframe, selected, trackUIEvent])

  return (
    <TimeframeInlineDropdown
      entities={ options }
      selected={ selectedOption }
      qaMarker='timeframe-dropdown'
      onSelect={ handleSelectTimeframe }
      className={ className }
      captionClassName={ captionClassName }
      withArrow={ withArrow }
    />
  )
}
